import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { PolicyControlModel } from 'app/_models/policy-control.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-policy-control",
  templateUrl: "./policy-control-list.component.html",
  styleUrls: ["./policy-control-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolicyControlComponent implements OnInit, OnDestroy {

  @Input() ctyId: string;
  @Input() clientsPolicyControlExceptions = [];
  @Output() Change = new EventEmitter();
  public updateDialogOpened = false;
  public deleteDialogOpened = false;
  gridData = [];
  all = false;
  _policyList = [];
  private _subject$: Subject<boolean> = new Subject();
  editobject: PolicyControlModel = new PolicyControlModel();
  index: number;
  selectedPolicy = null;

  constructor() { }

  ngOnInit() {
    if (this.ctyId != undefined) {
      this.gridData = this.clientsPolicyControlExceptions;
    }
  }

  opened;
  deleteitem;
  List;
  public open(component, ToSend) {
    this[component + "Opened"] = true;
    this.opened = true;
    this.List = this.gridData;
    this.deleteitem = ToSend;
  }  
  openDetails() { 
    if(this.selectedPolicy != null)
    this.updatePolicy(this.selectedPolicy, this.index);
    this.selectedPolicy = null; 
  }
 
  onCellClick($event) {
    this.selectedPolicy = $event.dataItem
    this.index = this.gridData.findIndex(item => item === $event.dataItem);
  }
  updatePolicy(item: PolicyControlModel, _index: number): void {
    this.editobject = (item != null) ? item : new PolicyControlModel();
    this.index = (_index != null) ? _index : null;
    this.updateDialogOpened = true;
  }

  public updated(event): void {
    this.updateDialogOpened = false;
    if (event != null) {
      if (this.index == null || this.index < 0 || this.index >= this.gridData.length) {
        this.gridData.push(event);
      } else {
        this.gridData[this.index] = event;
      }
      this._policyList = this.gridData.map(element => ({ cpcId: element.cpcId, cpcCaseTypeId: element.cpcCaseTypeId, cpcCheckMethodId: element.cpcCheckMethodId, cpcOrganizationunitId: element.cpcOrganizationunitId }));
      this.Change.emit(this._policyList);
      this.gridData = [...this.gridData];
    }
  }

  public Delete(event) {
    this.deleteDialogOpened = event.dialogstatus;
    if (event.policycontrol != "") {
      this.gridData = this.gridData.filter((e) => e != this.deleteitem);
      this._policyList = this.gridData.map(element => ({ cpcId: element.cpcId, cpcCaseTypeId: element.cpcCaseTypeId, cpcCheckMethodId: element.cpcCheckMethodId, cpcOrganizationunitId: element.cpcOrganizationunitId }));
      this.Change.emit(this._policyList);
    }
    this.gridData = [...this.gridData];
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}